// removed by extract-text-webpack-plugin
module.exports = {"bg":"_1i_ZC","base":"_2ntMA","sectionHeader":"oLKLR","title":"_1skPx","content":"K6pNM","spinner":"_11Uea","list":"g2LPv","fieldset":"_2IK3t","form":"_3N9Bf","group":"X5gr3","footer":"_2TQMW"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerHierarchy/PartnerHierarchyDisplayForm.scss
// module id = 2441
// module chunks = 0